import React from 'react';
import { useTranslation } from 'react-i18next';

const WelcomeTitle = () => {
    const { t } = useTranslation();
    return <h2 className='home-welcome-title'>{t('welcomeToTheRestaurant')}</h2>;
};

export default WelcomeTitle;
